import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  ItemNotFound,
} from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostCategoryByRequestQuery extends AbstractGraphqlRequest<
  PostCategoryModel | ItemNotFound
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findOnePostCategoryBy($payload: PostCategoryRequestPayloadInput) {
        findOnePostCategoryBy(payload: $payload) {
          cover {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          description
          active
          createdAt
          updatedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let item = data.findOnePostCategoryBy;

    if (item) {
      return new PostCategoryModel(item);
    }

    return new ItemNotFound();
  }
}
